import { p } from '@/utils/content-blocks';

export const DOWNLOAD_APK = {
	version: '18.80',
	size: '82 MB',
	android: '4.4+',
	packageName: 'com.gbwhatsapp',
	lastUpdated: 'May 2026',
};

export const VERSION_INFO_ROWS = [
	{ label: 'Current Version', value: '18.80' },
	{ label: 'Package Name', value: 'com.gbwhatsapp' },
	{ label: 'File Size', value: '82 MB' },
	{ label: 'Android Version', value: '4.4 (KitKat) or higher' },
	{ label: 'Last Updated', value: 'May 2026' },
	{ label: 'License', value: 'Free (unofficial mod)' },
];

export const SYSTEM_REQUIREMENT_ROWS = [
	{ label: 'OS', value: 'Android 4.4 (KitKat) or above' },
	{ label: 'RAM', value: '2 GB or more recommended' },
	{ label: 'Storage', value: '~200 MB free (APK + cache)' },
	{ label: 'Internet', value: 'Required for SMS verification' },
	{ label: 'CPU', value: 'ARM / ARM64 (most phones); x86 only if build supports it' },
];

export const DOWNLOAD_SECTIONS = [
	{
		id: 'download-latest',
		h2: 'Download GB WhatsApp APK Latest Version',
		blocks: [
			p([
				{
					text: 'Tap the button above on your Android phone to pull the latest GB WhatsApp APK. If you are on desktop, download the file and move it with USB or cloud storage—do not rename the APK unless you know what you are doing.',
				},
			]),
			p([
				{
					text: 'Before you install, match version 18.80 and about 82 MB on this page. Random mirrors often swap in older packages that fail login or trigger temporary bans. After the file lands in Downloads, continue with ',
				},
				{ link: { to: '/install-gbwhatsapp/', text: 'How to Install GB WhatsApp APK' } },
				{ text: ' for unknown-sources and setup steps.' },
			]),
			p([
				{
					text: 'Already running an older mod? Read the ',
				},
				{ link: { to: '/gbwhatsapp-update/', text: 'GB WhatsApp Update Guide' } },
				{ text: ' to upgrade without wiping chats—install over the top when signatures match, but back up first.' },
			]),
		],
	},
	{
		id: 'file-info',
		h2: 'File Size and Version Information',
		blocks: [
			p([
				{
					text: 'GBWaps lists the build we track for 2026 so you can sanity-check any file before opening it. Developers re-release often; the About screen inside the app should still read 18.80 after install.',
				},
			]),
			p([
				{
					text: 'Package name stays on com.gbwhatsapp for most community builds—if your installer shows a different package, stop and re-download from gbwaps.com. Split APK bundles are rare on this mod; you usually get one 82 MB file.',
				},
			]),
		],
	},
	{
		id: 'system-requirements',
		h2: 'System Requirements for GB WhatsApp APK',
		blocks: [
			p([
				{
					text: 'Most Samsung, Xiaomi, Oppo, and Motorola phones on Android 10–15 handle v18.80 well. Low-RAM devices should close heavy games before install, and keep at least 200 MB free for extraction and cache.',
				},
			]),
			p([
				{ text: 'Need an older package for a budget phone? Start from ' },
				{ link: { to: '/', text: 'GB WhatsApp' } },
				{ text: ' home, then browse ' },
				{ link: { to: '/old-version/', text: 'GB WhatsApp Old Version' } },
				{ text: ' notes before picking a legacy APK.' },
			]),
		],
	},
	{
		id: 'safety-notice',
		h2: 'Safety Notice Before Downloading GB WhatsApp',
		blocks: [
			p([
				{
					text: 'GB WhatsApp is a third-party mod, not published by Meta. Download only from pages you trust, scan if something feels off, and back up chats before every fresh install or big version jump.',
				},
			]),
			p([
				{
					text: 'Play Protect may flag modified APKs—that warning is common. A wrong file size is a stronger red flag than a generic “harmful app” alert. Never grab “GB WhatsApp plus” from pop-up ads; those bundles often add adware.',
				},
			]),
			p([
				{
					text: 'Using a mod can lead to temporary or permanent account restrictions. Use a secondary number first if you are unsure, keep the official app for banking OTPs, and avoid mass-forwarding right after login.',
				},
			]),
		],
	},
];
